/**
 * Where a filter needs an optional access scope the shop has not granted: what it unlocks, and the
 * button that opens Shopify's grant modal (or, once granted, syncs what it unlocks again).
 */
export function ScopeGate({
  children,
  pending,
  action = "Allow access",
  onAllow,
}: {
  children: React.ReactNode;
  pending: boolean;
  action?: string;
  onAllow: () => void;
}) {
  return (
    <s-stack gap="small-200">
      <s-text color="subdued">{children}</s-text>
      <s-stack direction="inline">
        <s-button loading={pending || undefined} onClick={onAllow}>
          {action}
        </s-button>
      </s-stack>
    </s-stack>
  );
}
